import { useState, useEffect } from 'react';

import axios from 'axios';

import AccordionTables from './AccordionTables'
const DevuelveMarteriasDocente = (props) => {


  const data = props.datos
  const [cursosVigentes, setCursosVigentes] = useState()
  const [instanciaEvaluativa, setInstanciaEvaluativa] = useState()
  const obtieneInstancias = async (materias) => {
    const arrayFlat = materias.flat()
    const arraySinDuplicados = arrayFlat.filter((obj, index, self) =>
      index === self.findIndex((t) => (
        t.curso === obj.curso
      ))
    );
    setCursosVigentes(arraySinDuplicados)
    var datos = []
    var DatosFinales = []
    for (let index = 0; index < arraySinDuplicados.length; index++) {
      try {

        const element = await axios.post(
          "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveInstanciasNombreCurso/",
          { "nombreCurso":arraySinDuplicados[index].curso}, 
          
        );
       
        if (element.data.instanciaDevuelta.length > 0) {
        
          const elementoPlanto = element.data.instanciaDevuelta.flat()
          datos.push(elementoPlanto)
        }
      } catch { }

    }
    const esto = datos.flat().filter((obj, index, self) =>
      index === self.findIndex((t) => (
        t.curso === obj.curso
      ))
    );

    setInstanciaEvaluativa(datos.flat())

  }


  // const headers = data.length > 0 ? Object.keys(data[0]) : [];
  useEffect(() => {
    if (data && data.DatosMaterias) {
      obtieneInstancias(data.DatosMaterias);
    }
  }, []);
  return (
    <>

      {instanciaEvaluativa ? <>
        <AccordionTables data={data} estados={instanciaEvaluativa} cursos={cursosVigentes} />
      </> : ""}
    </>
  );
}

export default DevuelveMarteriasDocente;
